import { render, staticRenderFns } from "./NewCampaignStep21.vue?vue&type=template&id=70e3613e&scoped=true&"
import script from "./NewCampaignStep21.vue?vue&type=script&lang=js&"
export * from "./NewCampaignStep21.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaignStep21.vue?vue&type=style&index=0&id=70e3613e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3613e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VForm,
  VLayout,
  VRadio,
  VRadioGroup,
  VTextField,
})
